<template>
  <b-dropdown
    class="templates-notifications"
    variant="link"
    toggle-class="text-decoration-none"
    right
  >
    <template #button-content>
      <i class="icon-calendar text-light"></i>
    </template>

    <b-dropdown-text class="px-3">
      <strong class="text-light">Próximas aulas</strong>
    </b-dropdown-text>

    <div v-if="loading" class="text-center p-5">
      <b-spinner variant="primary" />
    </div>
    <div class="error p-4 text-center" v-else-if="error">
      Erro!
      <button class="btn-link link bg-transparent p-0 border-0" @click="load">
        Tentar novamente
      </button>
    </div>

    <div class="scroll" v-show="!loading && !error">
      <v-calendar
        title-position="left"
        :attributes="attrs"
        @update:to-page="newPage"
        @dayclick="clickDay"
        is-dark
      />

      <button
        v-for="c in ordernedItems.slice(0, limit)"
        class="event"
        :key="c.id"
        @click="openEventModal([c], '')"
      >
        {{ c.name }}
        <small>{{ toHumanDate(c.event_at, true) }}</small>
      </button>
      <div
        v-if="calendar && calendar.length > limit"
        class="d-flex justify-content-center py-2"
      >
        <button
          @click.prevent="limit = limit + 5"
          class="border-100 d-flex align-items-center"
        >
          <i class="icon-plus"></i>
        </button>
      </div>
    </div>

    <b-modal v-model="dialog" hide-header hide-footer centered>
      <button class="btn-close" @click="dialog = false">
        <i class="fa-regular fa-xmark fa-lg"></i>
      </button>
      <h5 v-if="selectedDate" class="text-center p-3">
        Eventos {{ selectedDate }}
      </h5>
      <div v-for="(item, index) in items" :key="index" class="p-3 text-light">
        <h6>
          {{ item.name }}<br />
          <small class="text-secondary">{{
            toHumanDate(item.event_at, true)
          }}</small>
        </h6>
        <div v-html="item.description" />
        <button class="btn btn-primary btn-sm" @click="addToCalendar(item)">
          <i class="icon-plus"></i> Adicionar ao Google Agenda
        </button>
      </div>
    </b-modal>
  </b-dropdown>
</template>

<script>
import { toHumanDate, toCalendarDate } from "@/functions/helpers";
import { mapState } from "vuex";

export default {
  data() {
    return {
      attrs: [],
      loading: false,
      error: false,
      date: null,
      dialog: false,
      items: [],
      selectedDate: "",
      limit: 25
    };
  },
  computed: {
    ...mapState("notifications", ["calendar"]),
    ordernedItems() {
      let arr = this.calendar;
      arr.sort(this.compare);
      arr.reverse();
      return arr;
    }
  },
  methods: {
    addToCalendar(item) {
      const startDate = toCalendarDate(item.event_at);
      const finishDate = toCalendarDate(item.finished_at);
      const details = encodeURIComponent(item.description);
      const title = encodeURIComponent(item.name);
      const googleCalendarUrl = `https://www.google.com/calendar/event?action=TEMPLATE&dates=${startDate}/${finishDate}&text=${title}&details=${details}`;
      window.open(googleCalendarUrl, "_blank");
    },
    compare(a, b) {
      if (a.event_at > b.event_at) {
        return -1;
      }
      if (a.event_at < b.event_at) {
        return 1;
      } else {
        return 0;
      }
    },
    toHumanDate,
    openEventModal(items, selectedDate) {
      this.selectedDate = selectedDate;
      if (items && items.length) {
        this.items = items;
        this.dialog = true;
      }
    },
    clickNotification(n) {
      if (["broadcast", "direct"].includes(n.type)) {
        this.message = n.message;
        this.dialog = true;
      }
    },
    clickDay(date) {
      const items = Object.keys(date.attributesMap).map(id =>
        this.calendar.find(i => parseInt(i.id) === parseInt(id))
      );
      this.openEventModal(items, date.ariaLabel);
    },
    load() {
      this.loading = true;
      this.error = false;

      const month = `${this.date.month}`.padStart(2, "0");
      const lastDay = new Date(
        this.date.year,
        this.date.month,
        0,
        12
      ).getDate();
      // const time = Date.now();
      // const day = new Date(time).getDate();
      const params = {
        event_at_after: `${this.date.year}-${month}-1`,
        event_at_before: `${this.date.year}-${month}-${lastDay}`
      };
      this.$store
        .dispatch("notifications/getCalendar", params)
        .then(() => {
          this.attrs = this.calendar.map(c => ({
            key: c.id,
            highlight: true,
            dates: new Date(c.event_at)
          }));
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    newPage(date) {
      this.date = date;
      this.load();
    }
  }
};
</script>

<style lang="scss" scoped>
.templates-notifications {
  em {
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
  }

  ::v-deep .dropdown-menu {
    min-width: 250px;
  }

  .content {
    line-height: 18px;
  }

  ::v-deep .dropdown-item {
    position: relative;
  }

  ::v-deep .dropdown-toggle::after {
    display: none;
  }

  i {
    font-size: 24px;

    @media screen and (max-width: 575px) {
      font-size: 20px;
    }
  }

  ::v-deep {
    .vc-container {
      border: none;
    }
  }

  .event {
    padding: 6px 12px;
    font-size: 13px;
    line-height: 16px;
    border: none;
    background: transparent;
    text-align: left;
    display: block;
    color: white;

    small {
      display: block;
      color: #bbb;
      font-size: 10px;
      line-height: 12px;
    }
  }

  .border-100 {
    border: 1px solid #00c5a9;
    border-radius: 100%;
    padding: 2px;
    background: transparent;
    i {
      color: #00c5a9;
      font-size: 10px;
    }
  }

  .scroll {
    max-height: 80vh;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
